import { render, staticRenderFns } from "./SoftwareComponentCommandList.vue?vue&type=template&id=479a71e3&"
import script from "./SoftwareComponentCommandList.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentCommandList.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentCommandList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports